import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Check } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Compte créé — votre essai Premium de 7 jours commence !");
      navigate("/app");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface flex flex-col items-center justify-center px-4 py-10">
      <Link to="/" className="mb-6"><Logo size={80} /></Link>
      <Card className="w-full max-w-md p-8 bg-white adminia-fade-in">
        <h1 className="font-heading font-bold text-2xl text-brand mb-1">Créer mon compte</h1>
        <p className="text-sm text-muted-foreground mb-4">7 jours d'essai Premium offerts, sans engagement.</p>
        <div className="flex flex-wrap gap-3 mb-6 text-xs">
          {["Analyses illimitées 7j", "Aucune carte requise"].map((t) => (
            <span key={t} className="inline-flex items-center gap-1 text-success"><Check className="h-3.5 w-3.5" /> {t}</span>
          ))}
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="name">Prénom / Nom</Label>
            <Input id="name" required value={name} className="h-12 mt-1"
              onChange={(e) => setName(e.target.value)} data-testid="register-name" />
          </div>
          <div>
            <Label htmlFor="email">E-mail</Label>
            <Input id="email" type="email" required value={email} className="h-12 mt-1"
              onChange={(e) => setEmail(e.target.value)} data-testid="register-email" />
          </div>
          <div>
            <Label htmlFor="password">Mot de passe (6 caractères min.)</Label>
            <Input id="password" type="password" required minLength={6} value={password} className="h-12 mt-1"
              onChange={(e) => setPassword(e.target.value)} data-testid="register-password" />
          </div>
          <Button type="submit" disabled={loading}
            className="w-full h-12 rounded-full bg-brand hover:bg-brand/90 text-base" data-testid="register-submit">
            {loading ? "Création…" : "Créer mon compte"}
          </Button>
        </form>
        <p className="text-sm text-center mt-6 text-muted-foreground">
          Déjà inscrit ?{" "}
          <Link to="/connexion" className="text-brand font-semibold" data-testid="to-login">Se connecter</Link>
        </p>
      </Card>
    </div>
  );
}
